import { render, staticRenderFns } from "./PatchNotes.vue?vue&type=template&id=9cf2d082&scoped=true&"
import script from "./PatchNotes.vue?vue&type=script&lang=js&"
export * from "./PatchNotes.vue?vue&type=script&lang=js&"
import style0 from "./PatchNotes.vue?vue&type=style&index=0&id=9cf2d082&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf2d082",
  null
  
)

export default component.exports